(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5356],{

/***/ 5336:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseEach = __webpack_require__(89881);

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  baseEach(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

module.exports = baseFilter;


/***/ }),

/***/ 63105:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(34963),
    baseFilter = __webpack_require__(5336),
    baseIteratee = __webpack_require__(67206),
    isArray = __webpack_require__(1469);

/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */
function filter(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = filter;


/***/ }),

/***/ 53021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ slim_footer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
// EXTERNAL MODULE: ./components/core/short-footer/short-footer.js + 4 modules
var short_footer = __webpack_require__(69861);
// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/footer-category/footer-category-component.js + 1 modules
var footer_category_component = __webpack_require__(70212);
// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/long-footer.scss.js
var long_footer_scss = __webpack_require__(17619);
// EXTERNAL MODULE: ./constants/links.js + 20 modules
var links = __webpack_require__(27639);
// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/footer-bottom-bar/footer-bottom-bar-component.js + 10 modules
var footer_bottom_bar_component = __webpack_require__(46374);
// EXTERNAL MODULE: ./services/localization/localization-service.js
var localization_service = __webpack_require__(99952);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./segments/desktop/core-components/slim-footer/default-props.js
/* harmony default export */ var default_props = ({});

;// CONCATENATED MODULE: ./segments/desktop/core-components/slim-footer/slim-footer.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}











var SlimFooter = function(props) {
    var translate = props.translate, localeId = props.localeId, abTests = props.abTests, pageClusterConfig = props.pageClusterConfig, useProductMiniSiteConfig = props.useProductMiniSiteConfig;
    var SLIM_FOOTER = "slim";
    var renderShortFooter = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(short_footer/* default */.Z, _object_spread({}, props));
    };
    var renderSlimFooter = function() {
        var getFullFooterForLocalized = true;
        var footerComponents = (0,localization_service/* getFooterComponents */.L8)(localeId, abTests, getFullFooterForLocalized, {
            pageClusterConfig: pageClusterConfig,
            useProductMiniSiteConfig: useProductMiniSiteConfig
        });
        var SlimFooterLinks = footerComponents.SlimFooterLinks;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(long_footer_scss/* StyledFooter */.tc, {
            className: classnames_default()("footer-container", "slim-footer"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "footer-content-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                        className: "footer-content",
                        "aria-label": "Footer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "categories-container",
                            children: SlimFooterLinks.map(function(column, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                        type: column.type,
                                        links: column.links,
                                        hasMondayLogoTitle: index === 0
                                    })
                                });
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_bottom_bar_component/* default */.Z, {
                    SocialFooterLinks: links/* SocialFooterLinks */.Ff7,
                    footerType: SLIM_FOOTER
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(long_footer_scss/* StyledDesktopFooterContainer */.w2, {
                className: "footer-desktop-wrapper",
                children: renderSlimFooter()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(long_footer_scss/* StyledMobileFooterContainer */.qJ, {
                className: "footer-mobile-wrapper",
                children: renderShortFooter()
            })
        ]
    });
};
/* harmony default export */ var slim_footer = ((0,ab_tests_context/* withAbTests */.k)((0,generic_config_context/* withGenericConfig */.P)(SlimFooter)));
SlimFooter.defaultProps = default_props;


/***/ }),

/***/ 97545:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ SlimFooterComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/core-components/slim-footer/slim-footer.js + 1 modules
var slim_footer = __webpack_require__(53021);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/footer/layouts/slim-footer/slim-footer-component.scss.js

var StyledSlimFooterComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e123s6kx0"
})("margin:auto;");

;// CONCATENATED MODULE: ./segments/desktop/footer/layouts/slim-footer/slim-footer-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}




var SlimFooterComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(SlimFooterComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(SlimFooterComponent);
    function SlimFooterComponent() {
        (0,_class_call_check/* default */.Z)(this, SlimFooterComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(SlimFooterComponent, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSlimFooterComponent, {
                    className: "slim-footer-component",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(slim_footer/* default */.Z, _object_spread({}, this.props))
                });
            }
        }
    ]);
    return SlimFooterComponent;
}(react.PureComponent);

SlimFooterComponent.defaultProps = {};


/***/ })

}]);